import { render, staticRenderFns } from "./RightFooter.vue?vue&type=template&id=530434c8&scoped=true"
import script from "./RightFooter.vue?vue&type=script&lang=js"
export * from "./RightFooter.vue?vue&type=script&lang=js"
import style0 from "./RightFooter.vue?vue&type=style&index=0&id=530434c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530434c8",
  null
  
)

export default component.exports